import { getParentStructurePath } from '../../Common/PropertyPaths';

export const getTreatmentSupportAndRecovery = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = getParentStructurePath(planIndex, coverageIndex);

  return {
    unitsOfTreatmentSupportAndRecovery: `${parentPath}.unitsOfTreatmentSupportAndRecovery`,
    isCompanionNonLocalLodgingApplied: `${parentPath}.isCompanionNonLocalLodgingApplied`,
    isMedicalEquipmentApplied: `${parentPath}.isMedicalEquipmentApplied`,
    isMedicalSuppliesApplied: `${parentPath}.isMedicalSuppliesApplied`,
    isMedicationApplied: `${parentPath}.isMedicationApplied`,
    isNonLocalTransportationApplied: `${parentPath}.isNonLocalTransportationApplied`,
    isPostAccidentCommonCarrierTransportationApplied: `${parentPath}.isPostAccidentCommonCarrierTransportationApplied`,
    isProsthesisApplied: `${parentPath}.isProsthesisApplied`,
    isResidenceAutomobileModificationApplied: `${parentPath}.isResidenceAutomobileModificationApplied`,
    isTherapyApplied: `${parentPath}.isTherapyApplied`,
    isSpinalManipulationServicesApplied: `${parentPath}.isSpinalManipulationServicesApplied`,

    // Non Local Companion Details
    companionNonLocalLodgingDetails: {
      incurralPeriod: `${parentPath}.companionNonLocalLodgingDetails.incurralPeriod`,
      distanceToHospitalMoreThanMilesCd: `${parentPath}.companionNonLocalLodgingDetails.distanceToHospitalMoreThanMilesCd`,
      benefitAmount: `${parentPath}.companionNonLocalLodgingDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.companionNonLocalLodgingDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.companionNonLocalLodgingDetails.timePeriodCd`,
    },

    // Medical Equipment Details
    medicalEquipmentDetails: {
      incurralPeriod: `${parentPath}.medicalEquipmentDetails.incurralPeriod`,
      benefitAmount: `${parentPath}.medicalEquipmentDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.medicalEquipmentDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.medicalEquipmentDetails.timePeriodCd`,
    },

    // Medical Supplies Details
    medicalSuppliesDetails: {
      incurralPeriod: `${parentPath}.medicalSuppliesDetails.incurralPeriod`,
      benefitAmount: `${parentPath}.medicalSuppliesDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.medicalSuppliesDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.medicalSuppliesDetails.timePeriodCd`,
    },

    // Medication Details
    medicationDetails: {
      incurralPeriod: `${parentPath}.medicationDetails.incurralPeriod`,
      benefitAmount: `${parentPath}.medicationDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.medicationDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.medicationDetails.timePeriodCd`,
    },
    // Non Local Transportation Details
    nonLocalTransportationDetails: {
      incurralPeriod: `${parentPath}.nonLocalTransportationDetails.incurralPeriod`,
      travelDistanceMoreThan: `${parentPath}.nonLocalTransportationDetails.travelDistanceMoreThan`,
      benefitAmount: `${parentPath}.nonLocalTransportationDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.nonLocalTransportationDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.nonLocalTransportationDetails.timePeriodCd`,
    },

    //Post Accident Common Carrier Transportation Details
    postAccidentCommonCarrierTransportationDetails: {
      incurralPeriod: `${parentPath}.postAccidentCommonCarrierTransportationDetails.incurralPeriod`,
      travelDistanceMoreThan: `${parentPath}.postAccidentCommonCarrierTransportationDetails.travelDistanceMoreThan`,
      benefitAmount: `${parentPath}.postAccidentCommonCarrierTransportationDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.postAccidentCommonCarrierTransportationDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.postAccidentCommonCarrierTransportationDetails.timePeriodCd`,
    },

    // Prosthesis Details
    prosthesisDetails: {
      incurralPeriod: `${parentPath}.prosthesisDetails.incurralPeriod`,
      oneDeviceAmount: `${parentPath}.prosthesisDetails.oneDeviceAmount.amount`,
      twoOrMoreDevicesAmount: `${parentPath}.prosthesisDetails.twoOrMoreDevicesAmount.amount`,
      maxBenefitNumber: `${parentPath}.prosthesisDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.prosthesisDetails.timePeriodCd`,
    },

    // Residence Automobile Modification Details
    residenceAutomobileModificationDetails: {
      incurralPeriod: `${parentPath}.residenceAutomobileModificationDetails.incurralPeriod`,
      benefitAmount: `${parentPath}.residenceAutomobileModificationDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.residenceAutomobileModificationDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.residenceAutomobileModificationDetails.timePeriodCd`,
    },

    // Therapy Details
    therapyDetails: {
      therapyDetails: `${parentPath}.therapyDetails`,
      incurralPeriod: `${parentPath}.therapyDetails.incurralPeriod`,
      benefitAmount: `${parentPath}.therapyDetails.benefitAmount.amount`,
      isAlternateTherapyApplied: `${parentPath}.therapyDetails.isAlternateTherapyApplied`,
      maxBenefitNumber: `${parentPath}.therapyDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.therapyDetails.timePeriodCd`,
    },

    // SpinalManipulationServicesDetails
    spinalManipulationServicesDetails: {
      spinalManipulationServicesDetails: `${parentPath}.spinalManipulationServicesDetails`,
      incurralPeriod: `${parentPath}.spinalManipulationServicesDetails.incurralPeriod`,
      benefitAmount: `${parentPath}.spinalManipulationServicesDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.spinalManipulationServicesDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.spinalManipulationServicesDetails.timePeriodCd`,
    },
  };
};
